var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bd-layout-template-wrapper",class:_vm.classObj},[_c('bd-layout-' + _vm.theme.layout,{tag:"component",attrs:{"collapse":_vm.collapse,"device":_vm.device,"fixed-header":_vm.theme.fixedHeader}}),_c('el-backtop',{attrs:{"target":"#app"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }